/**
 * Minimal UtilityFunctions for participant-ui
 * Extracted from udaserve_dev/src/utilities/UtilityFunctions.js
 */

export const handleCheck = (claims, val, accountType, check = true) => {
  return (accountType === "STANDARD" ||
    accountType === "PROFESSIONAL" ||
    accountType === "ENTERPRISE") &&
    val.indexOf("ROLE_ADMIN") !== -1 &&
    check
    ? (claims &&
        Object.keys(claims).filter((r) => r.includes("ROLE_")).length === 0) ||
        Object.keys(claims).some((r) => val.some((check) => r.includes(check)))
    : Object.keys(claims).some((r) => val.some((check) => r.includes(check)));
};

export function parseJwt(token) {
  let base64Url = token.split(".")[1];
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(""),
  );

  return JSON.parse(jsonPayload);
}

/**
 * IndexedDB helpers shared by FirebaseUtil and any other store consumers.
 * Ported from udaserve_dev/src/utilities/UtilityFunctions.js.
 */
export function openDb(
  setDb,
  DB_NAME,
  DB_VERSION,
  DB_STORE_NAMES,
  USER_GEN_ID = false,
) {
  if (typeof window === "undefined") return;
  const req = indexedDB.open(DB_NAME, DB_VERSION);
  req.onsuccess = function () {
    setDb(this.result);
  };
  req.onerror = function (evt) {
    console.error("openDb:", evt.target.errorCode);
  };
  req.onupgradeneeded = function (evt) {
    const db = evt?.target?.result;
    DB_STORE_NAMES.forEach((storeName) => {
      if (!db?.objectStoreNames.contains(storeName)) {
        evt.currentTarget.result.createObjectStore(storeName, {
          keyPath: "id",
          autoIncrement: !USER_GEN_ID,
        });
      }
    });
    db?.addEventListener("versionchange", () => {
      console.log("The version of this database has changed");
    });
  };
}

export function getObjectStore(db, storeName, mode) {
  const tx = db.transaction(storeName, mode);
  return tx.objectStore(storeName);
}

export function stripHtml(str) {
  if (!str || typeof str !== "string") return str;
  return str.replace(/<[^>]*>/g, "").trim();
}
